import { render, staticRenderFns } from "./OsobaUmanjeniSatForma.vue?vue&type=template&id=422e8604&scoped=true&"
import script from "./OsobaUmanjeniSatForma.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSatForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e8604",
  null
  
)

export default component.exports